import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Carolina M.',
  image: 'https://i.pravatar.cc/150?img=5',
  text: 'Llevaba meses despertándome a las 3:15 AM exactas. Pensaba que era estrés, pero nada funcionaba. La primera noche que apliqué el protocolo, dormí hasta las 6:30 AM. Me sentí yo misma otra vez, sin esa niebla mental constante.',
  role: 'Mamá y Emprendedora'
}, {
  id: 2,
  name: 'Sofia R.',
  image: 'https://i.pravatar.cc/150?img=9',
  text: 'Mi marido me decía que estaba irritable todo el tiempo. Y tenía razón, estaba agotada. No creí que algo tan simple pudiera cambiar tanto mi descanso. Ahora tengo paciencia y energía para jugar con mis hijos.',
  role: 'Arquitecta'
}, {
  id: 3,
  name: 'Elena V.',
  image: 'https://i.pravatar.cc/150?img=1',
  text: 'Había probado melatonina, tés, meditación... nada evitaba que mi cerebro se encendiera en la madrugada. Entender por qué pasaba fue la clave. Ya no le tengo miedo a irme a dormir.',
  role: 'Abogada'
}, {
  id: 4,
  name: 'Valentina P.',
  image: 'https://i.pravatar.cc/150?img=32',
  text: 'Lo mejor no es solo dormir bien, es dejar de sentir ansiedad cuando llega la noche. El protocolo es lógico y fácil de seguir. Recuperé mis mañanas y mi buen humor.',
  role: 'Diseñadora'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-gradient-to-b from-[var(--bg-primary)] to-[var(--bg-deepest)] overflow-hidden" data-id="element-157">
      <div className="max-w-6xl mx-auto" data-id="element-158">
        <SectionWrapper data-id="element-159">
          <div className="text-center mb-16" data-id="element-160">
            <h2 className="text-3xl md:text-5xl font-serif text-[var(--text-primary)] mb-6" data-id="element-161">
              Testimonios Reales
            </h2>
            <p className="text-xl text-[var(--text-secondary)] max-w-2xl mx-auto" data-id="element-162">
              Lo que dicen quienes ya recuperaron sus noches (y sus días).
            </p>
          </div>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-163">
          {testimonials.map((testimonial, index) => <SectionWrapper key={testimonial.id} delay={index * 0.1 + 0.2} data-id="element-164">
              <div className="h-full p-8 rounded-3xl bg-[var(--bg-card)] border border-[var(--accent-amber)]/10 hover:border-[var(--accent-amber)]/30 transition-colors duration-300 relative group" data-id="element-165">
                {/* Quote icon decoration */}
                <div className="absolute top-8 right-8 text-[var(--accent-teal)]/10 group-hover:text-[var(--accent-teal)]/20 transition-colors text-6xl font-serif leading-none select-none" data-id="element-166">
                  "
                </div>

                <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-167">
                  <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[var(--accent-amber)]/20 shadow-lg" data-id="element-168">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-169" />
                  </div>
                  <div data-id="element-170">
                    <h3 className="font-bold text-[var(--text-primary)] text-lg" data-id="element-171">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-[var(--accent-teal)]" data-id="element-172">
                      {testimonial.role}
                    </p>
                  </div>
                </div>

                <div className="flex gap-1 mb-4 text-[var(--accent-amber)]" data-id="element-173">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-174" />)}
                </div>

                <p className="text-[var(--text-secondary)] text-lg italic font-serif leading-relaxed relative z-10" data-id="element-175">
                  "{testimonial.text}"
                </p>
              </div>
            </SectionWrapper>)}
        </div>
      </div>
    </section>;
}